import * as firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyA_RPtOJ6ZPkJ4bbOH3V3AbMuKAywWXSGM",
  authDomain: "leadsurf-dbad9.firebaseapp.com",
  databaseURL: "https://leadsurf-dbad9.firebaseio.com",
  projectId: "leadsurf-dbad9",
  storageBucket: "leadsurf-dbad9.appspot.com",
  messagingSenderId: "496294049681",
  appId: "1:496294049681:web:14ea39984b65515b9ecc30",
  measurementId: "G-DSZT4D6N8G"
  };
  

  firebase.initializeApp(firebaseConfig)
  firebase.auth().languageCode = 'nb'

  export const regularAuth = firebase.auth
  export const auth = firebase.auth()
  export const storage = firebase.storage()
  export const database = firebase.firestore()

  